import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ROLE_HOME } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleSession } = useAuth();

  useEffect(() => {
    let ignore = false;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        if (ignore) return;
        // Clean URL fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        const home = ROLE_HOME[user.role] || "/app/parent";
        navigate(home, { replace: true, state: { user } });
      } catch (e) {
        navigate("/login?error=session_failed", { replace: true });
      }
    })();
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper">
      <div className="text-center" data-testid="auth-callback-loader">
        <div className="w-12 h-12 mx-auto rounded-full border-4 border-terracotta border-t-transparent animate-spin" />
        <p className="mt-4 font-heading text-ink">Welcoming you back…</p>
      </div>
    </div>
  );
}
